import { gql } from "@apollo/client";

export default gql`
  mutation importPrivateJobs($file: Upload!) {
    importPrivateJobs(file: $file)
  }
`;
